// Nyra AI content — from Nyra_AI_Website_Content.docx (CERF Solutions Pvt. Ltd.)

export const BRAND = {
    name: "Nyra AI",
    tagline: "Meet Nyra AI — Automate. Execute. Scale",
    logo: "/nyra-logo.png",
    positioning:
        "From conversational assistants to autonomous agentic workflows — Nyra AI is the intelligence layer for the modern enterprise. Build your own AI assistant with no code, no complexity, no compromise.",
    boilerplate:
        "Nyra AI is a flagship Artificial Intelligence initiative — an enterprise AI assistant and agentic AI platform that helps organizations converse, automate, and decide with confidence. Trusted by enterprises across Banking & NBFC, Insurance, Healthcare, Retail & E-commerce, Manufacturing, and Government. SOC 2 Compliant.",
    company: "Nyra AI",
    phone: "+91-7428923652",
    emailSupport: "help@nyrabot.ai",
    emailSales: "help@nyrabot.ai",
};

export const NAV = [
    { label: "Home", to: "/" },
    {
        label: "Solutions",
        to: "/solutions",
        children: [
            { label: "Nyra Assist", to: "/solutions/nyra-assist", icon: "fa-solid fa-hands-holding-circle", desc: "Enterprise AI assistant for employees, customers & operations." },
            { label: "Nyra Knowledge", to: "/solutions/nyra-knowledge", icon: "fa-solid fa-book-open", desc: "Enterprise knowledge intelligence with grounded, citation-backed AI." },
            { label: "TenderIQ", to: "/solutions/tenderiq", icon: "fa-solid fa-file-signature", desc: "AI-powered tender evaluation & screening." },
        ],
    },
    {
        label: "Platform",
        to: "/platform",
        children: [
            { label: "Conversational AI Engine", to: "/platform", icon: "fa-solid fa-brain", desc: "Intent, entities, and grounded reasoning." },
            { label: "Agentic AI & Decisions", to: "/platform", icon: "fa-solid fa-bolt", desc: "Plan-act-approve autonomous flows." },
            { label: "Omnichannel Engagement", to: "/platform", icon: "fa-solid fa-network-wired", desc: "Web, WhatsApp, voice, email — unified." },
            { label: "Analytics & Insights", to: "/platform", icon: "fa-solid fa-chart-column", desc: "Full trace, sentiment, and SLAs." },
            { label: "Enterprise Integration", to: "/platform", icon: "fa-solid fa-plug", desc: "CRM, ERP, ticketing, telephony, BYOK." },
        ],
    },
    {
        label: "Use Cases",
        to: "/use-cases",
        children: [
            { label: "Healthcare", to: "/use-cases#healthcare", icon: "fa-solid fa-stethoscope", desc: "Patient journeys, triage, bookings." },
            { label: "E-commerce & Retail", to: "/use-cases#ecommerce", icon: "fa-solid fa-bag-shopping", desc: "Sales, support, retention on WhatsApp." },
            { label: "Banking & Finance", to: "/use-cases#banking", icon: "fa-solid fa-building-columns", desc: "Digital banking, reminders, disputes." },
            { label: "Travel & Hospitality", to: "/use-cases#travel", icon: "fa-solid fa-plane", desc: "Bookings, confirmations, loyalty." },
            { label: "Insurance", to: "/use-cases#insurance", icon: "fa-solid fa-umbrella", desc: "Quotes, issuance, claims, renewals." },
            { label: "Real Estate", to: "/use-cases#real-estate", icon: "fa-solid fa-house", desc: "Lead capture, listings, visit booking." },
            { label: "Education & EdTech", to: "/use-cases#education", icon: "fa-solid fa-graduation-cap", desc: "Admissions, reminders, student FAQs." },
            { label: "Logistics & Delivery", to: "/use-cases#logistics", icon: "fa-solid fa-truck", desc: "Live tracking, alerts, resolutions." },
            { label: "Customer Stories", to: "/customer-stories", icon: "fa-solid fa-book-open-reader", desc: "Real deployments powered by Nyra AI." },
        ],
    },
    { label: "Contact Us", to: "/contact" },
];

export const CAPABILITIES_HOME = [
    {
        key: "engage",
        icon: "fa-solid fa-comments",
        title: "Engage",
        body: "Meet customers on any channel — web, chat, voice, WhatsApp — with human-like conversations that answer, qualify, and delight in real time.",
    },
    {
        key: "automate",
        icon: "fa-solid fa-bolt",
        title: "Automate",
        body: "From bookings and order tracking to claims filing and EMI reminders — NyraAI runs the whole conversation and integrates with your CRM, ticketing, and telephony stack.",
    },
    {
        key: "scale",
        icon: "fa-solid fa-arrows-up-down-left-right",
        title: "Scale",
        body: "24×7 availability, multilingual support, and consistent brand voice across every interaction — so you scale customer engagement without scaling headcount.",
    },
];

export const WHY_NYRA = [
    {
        icon: "fa-solid fa-plug",
        title: "Plugs into your stack.",
        body: "Connects to your CRM, ticketing, telephony, and IVR — augmenting what you already have rather than replacing it.",
    },
    {
        icon: "fa-solid fa-language",
        title: "Speaks your customer's language.",
        body: "Multilingual out of the box — English, Hindi, and major Indian languages so you reach customers where they are.",
    },
    {
        icon: "fa-solid fa-user-check",
        title: "Human handoff, done right.",
        body: "Warm transfers to your live agents the moment intent or emotion demands a human — with full conversation context.",
    },
    {
        icon: "fa-solid fa-shield-halved",
        title: "Enterprise-grade security.",
        body: "SOC 2 compliant. Private deployments, RBAC, and full audit trails on every conversation.",
    },
];

export const PIPELINE_STEPS = [
    { title: "Understand", body: "the intent behind the request.", icon: "fa-solid fa-ear-listen" },
    { title: "Retrieve", body: "the relevant knowledge from your systems.", icon: "fa-solid fa-database" },
    { title: "Reason", body: "across policies, context, and options.", icon: "fa-solid fa-microchip" },
    { title: "Recommend", body: "an action with a confidence score and its sources.", icon: "fa-solid fa-lightbulb" },
    { title: "Approve", body: "a human signs off where it matters.", icon: "fa-solid fa-signature" },
    { title: "Execute", body: "the workflow across connected systems.", icon: "fa-solid fa-play" },
    { title: "Audit", body: "every step is logged and observable.", icon: "fa-solid fa-clipboard-check" },
];

export const PLATFORM_GROUPS = [
    {
        key: "reason",
        title: "Reason & Orchestrate",
        icon: "fa-solid fa-diagram-project",
        items: [
            { name: "Intent recognition + dynamic workflows", body: "Understands what customers want and drives the conversation to resolution." },
            { name: "Live-agent transfer", body: "Warm handoff to your team with full conversation context, the moment it's needed." },
        ],
    },
    {
        key: "retrieve",
        title: "Retrieve & Ground",
        icon: "fa-solid fa-magnifying-glass",
        items: [
            { name: "Enterprise Knowledge Search (RAG)", body: "Answers grounded in your product data, policies, and FAQs — with sources attached." },
            { name: "CRM & telephony integrations", body: "Plugs into your CRM, ticketing, and telephony/IVR so bots work with live customer data." },
        ],
    },
    {
        key: "govern",
        title: "Govern & Trust",
        icon: "fa-solid fa-scale-balanced",
        items: [
            { name: "Brand-safe responses", body: "Every reply consistent with your brand guidelines and approved language." },
            { name: "Analytics & observability", body: "Call intent, resolution, sentiment, deflection — measured on every conversation." },
        ],
    },
    {
        key: "deploy",
        title: "Deploy & Secure",
        icon: "fa-solid fa-shield-halved",
        items: [
            { name: "Secure private deployments", body: "Your data, your environment, RBAC, and full audit trails." },
            { name: "Multi-channel delivery", body: "One conversation logic, delivered to web, mobile, voice, WhatsApp, SMS, and email." },
        ],
    },
];

export const SOLUTIONS = [
    {
        slug: "nyra-assist",
        accent: "#2E7D6B",
        eyebrow: "Enterprise AI Assistant",
        title: "Nyra Assist",
        headline: "Enterprise AI assistant for employees, customers & business operations.",
        summary:
            "Nyra Assist is an enterprise-grade conversational AI assistant that combines large language models, enterprise knowledge, workflow automation, and business integrations to deliver intelligent, contextual, and action-oriented assistance across multiple channels.",
        shift:
            "Nyra Assist replaces delayed responses, high support costs, scattered knowledge, and repetitive employee queries with one intelligent assistant — natural conversations, grounded answers, automated workflows, and seamless human handover, all on one secure platform.",
        businessChallenges: [
            { icon: "fa-solid fa-clock", title: "Delayed customer response times" },
            { icon: "fa-solid fa-indian-rupee-sign", title: "High support costs" },
            { icon: "fa-solid fa-folder-tree", title: "Scattered enterprise knowledge" },
            { icon: "fa-solid fa-arrows-rotate", title: "Repetitive employee queries" },
            { icon: "fa-solid fa-file-lines", title: "Manual business processes" },
            { icon: "fa-solid fa-face-frown", title: "Inconsistent customer experiences" },
            { icon: "fa-solid fa-arrows-up-down-left-right", title: "Difficulty scaling operations" },
        ],
        capabilities: [
            "Conversational AI powered by advanced LLMs",
            "Enterprise Knowledge Integration — grounded answers",
            "Business Process Automation from query to action",
            "Multi-channel deployment (Web, WhatsApp, Voice, SMS, Email)",
            "Multilingual conversations",
            "Contextual & personalized responses with conversation memory",
            "AI Copilot for employees",
            "Seamless human handover",
        ],
        aiFeatures: [
            { icon: "fa-solid fa-comment-dots", label: "Question Answering" },
            { icon: "fa-solid fa-file-lines", label: "Document Summarization" },
            { icon: "fa-solid fa-face-smile", label: "Sentiment Analysis" },
            { icon: "fa-solid fa-crosshairs", label: "Intent Recognition" },
            { icon: "fa-solid fa-thumbs-up", label: "Recommendation Engine" },
            { icon: "fa-solid fa-brain", label: "Conversation Memory" },
            { icon: "fa-solid fa-language", label: "Translation" },
            { icon: "fa-solid fa-microphone-lines", label: "Voice Interaction" },
            { icon: "fa-solid fa-image", label: "Image Understanding" },
            { icon: "fa-solid fa-plug", label: "Enterprise API Actions" },
        ],
        industries: [
            { icon: "fa-solid fa-building-columns", name: "Banking & NBFC" },
            { icon: "fa-solid fa-umbrella", name: "Insurance" },
            { icon: "fa-solid fa-stethoscope", name: "Healthcare" },
            { icon: "fa-solid fa-bag-shopping", name: "Retail & E-commerce" },
            { icon: "fa-solid fa-user-tie", name: "HR" },
            { icon: "fa-solid fa-headset", name: "IT Service Desk" },
            { icon: "fa-solid fa-shield-halved", name: "Security & Governance" },
        ],
        architecture: {
            title: "How Nyra Assist works, end-to-end.",
            flow: [
                { label: "Users", icon: "fa-solid fa-user-group" },
                { label: "Channels", icon: "fa-solid fa-network-wired" },
                { label: "Nyra Assist", icon: "fa-solid fa-robot" },
                { label: "LLM + Conversation Manager + Workflow Engine + Nyra Knowledge", icon: "fa-solid fa-microchip" },
                { label: "Enterprise Systems", icon: "fa-solid fa-database" },
            ],
        },
        governance: [
            { icon: "fa-solid fa-user-lock", title: "RBAC & IAM Integration" },
            { icon: "fa-solid fa-lock", title: "Encryption at rest & in transit" },
            { icon: "fa-solid fa-clipboard-check", title: "Audit Logging" },
            { icon: "fa-solid fa-user-shield", title: "Privacy Controls" },
            { icon: "fa-solid fa-scale-balanced", title: "Compliance-ready" },
        ],
        deployments: ["SaaS", "Private Cloud", "Hybrid", "On-premises"],
        differentiators: [
            "Enterprise-ready AI assistant, not a chatbot",
            "Knowledge-grounded responses with citations",
            "End-to-end workflow automation",
            "Omnichannel deployment out of the box",
            "Secure, scalable, and compliance-ready",
            "Deep enterprise integrations (CRM, ERP, ITSM, telephony)",
        ],
        channels: ["Web", "WhatsApp", "Voice", "SMS", "Email", "RCS"],
        outcomes: [
            "Faster customer response times",
            "Lower support costs",
            "Consistent, always-on customer experience",
            "Higher employee productivity via AI Copilot",
        ],
        cta: "See Nyra Assist in action",
        icon: "fa-solid fa-hands-holding-circle",
        image: "https://images.unsplash.com/photo-1626863905121-3b0c0ed7b94c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        slug: "nyra-knowledge",
        accent: "#235F52",
        eyebrow: "Enterprise Knowledge Intelligence",
        title: "Nyra Knowledge",
        headline: "Enterprise Knowledge Intelligence Platform for Trusted AI.",
        summary:
            "Nyra Knowledge transforms your organization's scattered information into a secure, searchable, AI-ready knowledge repository — enabling employees, customers, and AI agents to retrieve accurate, citation-backed answers in real time.",
        shift:
            "Retrieval-Augmented Generation (RAG) grounds every answer in your approved enterprise documents, with source citations, page references, confidence scores, and role-based access — so your AI is not only helpful, but trustworthy and audit-ready.",
        knowledgeSources: [
            "Policies", "SOPs", "Product docs", "HR policies", "Legal docs",
            "Compliance guidelines", "Technical docs", "Sales playbooks",
            "FAQs", "Training materials", "Emails", "Meeting transcripts",
        ],
        ingestionSources: [
            { icon: "fa-brands fa-microsoft", name: "SharePoint" },
            { icon: "fa-brands fa-google-drive", name: "Google Drive" },
            { icon: "fa-brands fa-microsoft", name: "OneDrive" },
            { icon: "fa-brands fa-confluence", name: "Confluence" },
            { icon: "fa-solid fa-book", name: "Notion" },
            { icon: "fa-solid fa-globe", name: "Websites" },
            { icon: "fa-solid fa-database", name: "CRM / ERP" },
            { icon: "fa-solid fa-ticket", name: "Ticketing" },
            { icon: "fa-solid fa-file-pdf", name: "PDFs" },
            { icon: "fa-solid fa-file-word", name: "Office docs" },
            { icon: "fa-solid fa-eye", name: "OCR (images/scans)" },
            { icon: "fa-solid fa-microphone-lines", name: "Audio / Video transcripts" },
        ],
        capabilities: [
            "Enterprise Knowledge Repository — policies, SOPs, docs, FAQs, transcripts",
            "Multi-source ingestion (SharePoint, Drive, Confluence, Notion, CRM, ERP, PDFs, OCR)",
            "Semantic, hybrid, multilingual, context-aware intelligent search",
            "RAG-grounded answers backed by your approved documents",
            "Source, page, confidence & last-updated on every response",
            "Role-based access control — permission-aware retrieval",
            "Continuous automated knowledge sync",
            "Persistent AI Agent memory across HR, Sales, IT, Compliance, Legal, CX",
        ],
        aiFeatures: [
            { icon: "fa-solid fa-comments", label: "Conversational Q&A" },
            { icon: "fa-solid fa-file-lines", label: "Summarization" },
            { icon: "fa-solid fa-circle-question", label: "FAQ Generation" },
            { icon: "fa-solid fa-code-compare", label: "Document Comparison" },
            { icon: "fa-solid fa-language", label: "Translation" },
            { icon: "fa-solid fa-diagram-project", label: "Knowledge Graph" },
            { icon: "fa-solid fa-user-tie", label: "Expert Discovery" },
            { icon: "fa-solid fa-scale-balanced", label: "Policy Assistant" },
        ],
        industries: [
            { icon: "fa-solid fa-user-tie", name: "HR" },
            { icon: "fa-solid fa-building-columns", name: "Banking & NBFC" },
            { icon: "fa-solid fa-umbrella", name: "Insurance" },
            { icon: "fa-solid fa-industry", name: "Manufacturing" },
            { icon: "fa-solid fa-stethoscope", name: "Healthcare" },
        ],
        architecture: {
            title: "How Nyra Knowledge turns raw docs into trusted answers.",
            flow: [
                { label: "Enterprise Data Sources", icon: "fa-solid fa-database" },
                { label: "Ingestion & OCR", icon: "fa-solid fa-file-import" },
                { label: "Cleaning & Chunking", icon: "fa-solid fa-scissors" },
                { label: "Embeddings", icon: "fa-solid fa-vector-square" },
                { label: "Vector DB", icon: "fa-solid fa-cubes-stacked" },
                { label: "Nyra Knowledge", icon: "fa-solid fa-book-open" },
                { label: "LLM + RAG", icon: "fa-solid fa-microchip" },
                { label: "AI Assistants → Employees / Customers", icon: "fa-solid fa-user-group" },
            ],
        },
        governance: [
            { icon: "fa-solid fa-user-lock", title: "RBAC & permission-aware retrieval" },
            { icon: "fa-solid fa-lock", title: "Encryption at rest & in transit" },
            { icon: "fa-solid fa-clipboard-check", title: "Audit logs" },
            { icon: "fa-solid fa-code-branch", title: "Version control" },
            { icon: "fa-solid fa-arrows-spin", title: "Lifecycle management" },
            { icon: "fa-solid fa-map-location-dot", title: "Data residency" },
            { icon: "fa-solid fa-key", title: "SSO / LDAP" },
        ],
        deployments: ["SaaS", "Private Cloud", "Hybrid", "On-premises"],
        differentiators: [
            "Enterprise-grade knowledge integrated with Nyra AI",
            "Permission-aware retrieval with citations",
            "Multilingual support across Indian & global languages",
            "SaaS / Private Cloud / Hybrid / On-prem deployment",
            "Native omnichannel integration (WhatsApp, SMS, Email, Voice, RCS)",
            "Integration with DataRakshaq and Consentica for privacy compliance",
        ],
        channels: ["WhatsApp", "Web Chat", "CRM", "ERP", "Ticketing", "REST APIs", "MCP AI agents"],
        outcomes: [
            "Trustworthy, citation-backed AI answers",
            "Permission-aware retrieval across the enterprise",
            "Multilingual knowledge for global workforces",
            "Privacy-first — works with DataRakshaq and Consentica",
        ],
        cta: "Make your AI trustworthy — Explore Nyra Knowledge",
        icon: "fa-solid fa-book-open",
        image: "https://images.unsplash.com/photo-1758874384555-37d50c0ee81a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        slug: "tenderiq",
        accent: "#5FA88A",
        eyebrow: "AI-Powered Tender Scrutiny",
        title: "TenderIQ",
        headline: "AI-Powered Tender Evaluation & Screening System.",
        summary:
            "TenderIQ removes the manual bottleneck of procurement — automatically ingesting bidder submissions, extracting key data, validating compliance, and flagging shortfalls within minutes, with every finding traceable to source document and page.",
        shift:
            "Tender scrutiny is one of the most time-consuming, error-prone stages of procurement. TenderIQ turns thousands of pages of bidder submissions into structured, evidence-backed scrutiny reports — while the human review gate keeps the final decision with the evaluation authority.",
        businessChallenges: [
            { icon: "fa-solid fa-hourglass-half", title: "Days lost to manual bid review" },
            { icon: "fa-solid fa-triangle-exclamation", title: "Human error across thousands of pages" },
            { icon: "fa-solid fa-scale-unbalanced", title: "Inconsistent evaluations across bidders" },
            { icon: "fa-solid fa-magnifying-glass-minus", title: "Missing shortfalls slipping through review" },
            { icon: "fa-solid fa-boxes-stacked", title: "Fragmented data across multiple documents" },
            { icon: "fa-solid fa-clipboard-question", title: "No traceability between findings & source" },
            { icon: "fa-solid fa-file-excel", title: "Manual Excel report preparation" },
            { icon: "fa-solid fa-gavel", title: "Bidder disputes over evaluation outcomes" },
            { icon: "fa-solid fa-shield-halved", title: "Regulatory & audit scrutiny risk" },
            { icon: "fa-solid fa-file-image", title: "Poor OCR on scanned / image-based PDFs" },
            { icon: "fa-solid fa-users", title: "Limited evaluator capacity at scale" },
            { icon: "fa-solid fa-clock-rotate-left", title: "Slow decision-making cycles" },
        ],
        capabilities: [
            "Automated Document Parsing — ingests bidder submissions at scale",
            "Cross-Document Data Extraction across large tender packs",
            "Compliance Validation against eligibility & threshold criteria",
            "Shortfall Identification with clear evaluator remarks",
            "Document & Page Traceability — every output linked to source",
            "Excel Scrutiny Report generation in evaluator-ready format",
            "OCR on scanned certificates, stamps, and signed forms",
            "Side-by-side bidder comparison across evaluation matrix",
            "Auto-summary of technical & financial bids (BOQ)",
            "Confidence scoring on every extracted data point",
        ],
        aiFeatures: [
            { icon: "fa-solid fa-file-import", label: "Automated Document Parsing" },
            { icon: "fa-solid fa-table-list", label: "Cross-Document Data Extraction" },
            { icon: "fa-solid fa-clipboard-check", label: "Compliance Validation" },
            { icon: "fa-solid fa-triangle-exclamation", label: "Shortfall Identification" },
            { icon: "fa-solid fa-link", label: "Document & Page Traceability" },
            { icon: "fa-solid fa-file-excel", label: "Excel Scrutiny Report" },
            { icon: "fa-solid fa-eye", label: "OCR (Scanned Docs)" },
            { icon: "fa-solid fa-language", label: "Multilingual Bid Support" },
            { icon: "fa-solid fa-user-check", label: "Human Review Gate" },
            { icon: "fa-solid fa-gauge-high", label: "Confidence Scoring" },
            { icon: "fa-solid fa-code-compare", label: "Bidder Comparison" },
            { icon: "fa-solid fa-file-invoice-dollar", label: "BOQ Summarization" },
            { icon: "fa-solid fa-clock-rotate-left", label: "Audit Trail Generation" },
            { icon: "fa-solid fa-stamp", label: "Certificate Validation" },
            { icon: "fa-solid fa-magnifying-glass", label: "Contextual Search" },
        ],
        // Reusing ingestionSources block with a tender-specific heading (see SolutionDetail.jsx)
        ingestionEyebrow: "Document support",
        ingestionHeading: "Every bidder document, <em>understood</em>.",
        knowledgeSources: [
            "Technical Bid Forms", "Financial Bids (BOQ)", "Balance Sheets",
            "Audit Reports", "Turnover Statements", "EMD & Bid Security Proofs",
            "GST & Tax Registrations", "PAN & Corporate KYC", "ISO / Quality Certifications",
            "Prior Experience Certificates", "Compliance Undertakings", "Signed Declarations",
            "Client Reference Letters", "Manufacturer Authorizations", "Blacklisting Declarations",
        ],
        ingestionSources: [
            { icon: "fa-solid fa-file-pdf", name: "PDFs (native & scanned)" },
            { icon: "fa-solid fa-file-word", name: "MS Word (.doc/.docx)" },
            { icon: "fa-solid fa-file-excel", name: "Excel (.xls/.xlsx)" },
            { icon: "fa-solid fa-file-image", name: "Scanned Images (JPG/PNG)" },
            { icon: "fa-solid fa-file-zipper", name: "ZIP tender packs" },
            { icon: "fa-solid fa-stamp", name: "Signed & Stamped Certificates" },
            { icon: "fa-solid fa-file-signature", name: "Digitally Signed Bids" },
            { icon: "fa-solid fa-envelope", name: "Emailed Submissions" },
            { icon: "fa-solid fa-cloud", name: "Portal Downloads (GeM/CPPP)" },
            { icon: "fa-solid fa-language", name: "Bilingual (English/Hindi)" },
            { icon: "fa-solid fa-file-lines", name: "Rich Text / Plain Text" },
            { icon: "fa-solid fa-table", name: "Structured Tables & BOQs" },
        ],
        // Evaluation criteria that TenderIQ automatically checks — extra "what it extracts" block
        evaluationPoints: [
            { icon: "fa-solid fa-id-card", label: "Bidder Identity & KYC" },
            { icon: "fa-solid fa-money-bill-trend-up", label: "Turnover Thresholds" },
            { icon: "fa-solid fa-briefcase", label: "Prior Experience" },
            { icon: "fa-solid fa-piggy-bank", label: "Financial Capability" },
            { icon: "fa-solid fa-gears", label: "Technical Eligibility" },
            { icon: "fa-solid fa-certificate", label: "Certifications (ISO, MSME, etc.)" },
            { icon: "fa-solid fa-shield-halved", label: "EMD & Bid Security" },
            { icon: "fa-solid fa-receipt", label: "Tax Status (GST/PAN)" },
            { icon: "fa-solid fa-user-slash", label: "Blacklisting Checks" },
            { icon: "fa-solid fa-file-contract", label: "Compliance to Tender Terms" },
            { icon: "fa-solid fa-signature", label: "Signatures & Authorizations" },
            { icon: "fa-solid fa-calendar-check", label: "Validity & Deadline Adherence" },
        ],
        industries: [
            { icon: "fa-solid fa-industry", name: "Large Enterprise Procurement" },
            { icon: "fa-solid fa-landmark", name: "Public Sector & Government" },
            { icon: "fa-solid fa-helmet-safety", name: "Infrastructure & Construction" },
            { icon: "fa-solid fa-shield", name: "Defence & Aerospace" },
            { icon: "fa-solid fa-bolt", name: "Energy & Utilities" },
            { icon: "fa-solid fa-train", name: "Railways & Transportation" },
            { icon: "fa-solid fa-mound", name: "Mining & Metals" },
            { icon: "fa-solid fa-oil-can", name: "Oil & Gas" },
            { icon: "fa-solid fa-city", name: "Municipal Bodies & Smart Cities" },
            { icon: "fa-solid fa-hospital", name: "Healthcare Public Procurement" },
            { icon: "fa-solid fa-graduation-cap", name: "Higher Education & PSUs" },
            { icon: "fa-solid fa-building-columns", name: "Banking & PSU Tenders" },
        ],
        architecture: {
            title: "How TenderIQ scrutinizes a tender, end-to-end.",
            flow: [
                { label: "Bidder Submissions", icon: "fa-solid fa-file-arrow-up" },
                { label: "Document Parsing & OCR", icon: "fa-solid fa-file-import" },
                { label: "Data Extraction", icon: "fa-solid fa-table-list" },
                { label: "Compliance Engine + Tender Criteria", icon: "fa-solid fa-scale-balanced" },
                { label: "Shortfall & Evidence Mapping", icon: "fa-solid fa-magnifying-glass" },
                { label: "Human Review Gate", icon: "fa-solid fa-user-check" },
                { label: "Excel Scrutiny Report", icon: "fa-solid fa-file-excel" },
            ],
        },
        governance: [
            { icon: "fa-solid fa-user-check", title: "Human review gate on every decision" },
            { icon: "fa-solid fa-link", title: "Source & page traceability on all findings" },
            { icon: "fa-solid fa-clipboard-check", title: "Full audit trail per bidder" },
            { icon: "fa-solid fa-user-lock", title: "Role-based access for evaluators" },
            { icon: "fa-solid fa-lock", title: "Encryption at rest & in transit" },
            { icon: "fa-solid fa-map-location-dot", title: "India data-residency options" },
            { icon: "fa-solid fa-shield-halved", title: "CVC & GFR-aligned workflows" },
            { icon: "fa-solid fa-code-branch", title: "Versioned scrutiny reports" },
        ],
        deployments: ["SaaS", "Private Cloud", "Hybrid", "On-premises (Air-gapped)"],
        differentiators: [
            "Faster Evaluation — reviews bidder submissions in minutes, not days",
            "Evidence-Backed Results — every finding traceable to document & page",
            "Audit-Ready Output — transparency & accountability across scrutiny",
            "Human Oversight Preserved — final decision stays with evaluation authority",
            "Report Format Familiarity — Excel output matching evaluator workflows",
            "Purpose-built for tenders — not adapted from a generic document tool",
            "Handles scanned & image-based bids via enterprise-grade OCR",
            "Multilingual — evaluates bilingual (English / Hindi) submissions",
            "Air-gapped deployment for defence & sensitive public tenders",
        ],
        channels: ["Enterprise Procurement", "Public Sector Tenders", "Infrastructure & Construction Bidding"],
        outcomes: [
            "Reviews bidder submissions in minutes, not days",
            "Evidence-backed, audit-ready results",
            "Consistent evaluations across large volumes",
            "Human oversight preserved — final decision stays with the authority",
            "Fewer bidder disputes thanks to traceable, evidence-linked findings",
            "Frees evaluators to focus on judgement, not clerical checks",
        ],
        cta: "Streamline tender scrutiny — Request a Demo",
        icon: "fa-solid fa-file-signature",
        image: "https://images.unsplash.com/photo-1659355894515-2548f35525f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
];

/* -----------------------------------------------------------
   CUSTOMER STORIES — real deployments across regulated verticals
------------------------------------------------------------ */
export const CUSTOMER_STORIES = [
    {
        slug: "mitsde",
        name: "Leading Distance-Learning Institute",
        logoLetter: "D",
        industry: "Distance Education",
        accent: "#2E7D6B",
        channel: "AI Voice Assistant",
        channelIcon: "fa-solid fa-phone-volume",
        product: "Nyra Assist",
        background:
            "A leading Indian distance-learning institute offering specializations across Management, Information Technology, Data Science and AI — bridging critical industry skill gaps for working professionals.",
        challenge:
            "A relentless volume of student enquiries and inbound leads for distance-education programs — manual screening of qualified leads was slowing down counselors and hurting conversion.",
        solution: [
            "AI-powered multilingual voice call assistant",
            "Structured conversational flow for candidate profiling",
            "Real-time PGDM specialization recommendations based on education, experience & interests",
            "Automatic lead qualification, callback scheduling & human escalation",
        ],
        outcomes: [
            { label: "Counsellor workload", value: "Sharply reduced" },
            { label: "Lead conversion", value: "Higher quality" },
            { label: "Response time", value: "Instant, 24×7" },
            { label: "Availability", value: "Round-the-clock counselling" },
        ],
        quote:
            "Real-time counselling over the phone — recommending the right specialization to each student before a human ever picks up.",
    },
    {
        slug: "creditmantri",
        name: "Top Consumer Fintech Platform",
        logoLetter: "F",
        industry: "Fintech · Credit & Lending",
        accent: "#5FA88A",
        channel: "WhatsApp AI Chatbot",
        channelIcon: "fa-brands fa-whatsapp",
        product: "Nyra Assist",
        background:
            "A leading Indian fintech platform that provides free credit-score tracking, credit-health analysis and tailored loan / credit-card recommendations to millions of consumers.",
        challenge:
            "Users needed a low-friction way to proactively identify and resolve negative loan accounts on their credit profile — and a trusted advisor to guide them on CIBIL scores and loan management.",
        solution: [
            "Negative loan-account identification from the user's credit profile",
            "In-chat request raising for loan settlement or account closure",
            "Real-time status updates on pending closure or settlement actions",
            "AI-generated financial guidance on CIBIL, credit scores & loan management",
        ],
        outcomes: [
            { label: "Barrier to engage", value: "Lowered" },
            { label: "Credit issue resolution", value: "On-chat, self-serve" },
            { label: "User trust", value: "Deeper engagement" },
            { label: "Retention", value: "Higher" },
        ],
        quote:
            "Credit support that meets users on India's most-used messaging platform — resolving issues without a call or app switch.",
    },
];


export const USE_CASES = [
    {
        key: "healthcare",
        accent: "#A8B36E",
        name: "Healthcare",
        subtitle: "How NyraAI automates patient journeys for hospitals, clinics, and diagnostics.",
        icon: "fa-solid fa-stethoscope",
        bullets: [
            "Instant appointment booking and rescheduling",
            "Symptom pre-screening and triage",
            "Automated prescription refills and reminders",
            "24/7 FAQs on doctors, services, and insurance",
            "Reduces front-desk workload significantly",
        ],
    },
    {
        key: "ecommerce",
        accent: "#D4B542",
        name: "E-commerce & Retail",
        subtitle: "How NyraAI drives sales, support, and retention on WhatsApp.",
        icon: "fa-solid fa-bag-shopping",
        bullets: [
            "Personalized product recommendations",
            "Real-time order tracking and returns",
            "Abandoned cart recovery campaigns",
            "In-chat customer feedback collection",
            "Re-engagement for new launches and sales",
        ],
    },
    {
        key: "banking",
        accent: "#5FA88A",
        name: "Banking & Finance",
        subtitle: "How NyraAI simplifies digital banking for customers.",
        icon: "fa-solid fa-building-columns",
        bullets: [
            "Secure balance and transaction queries",
            "Guided loan and card applications",
            "Instant fraud alerts and disputes",
            "Proactive EMI and due-date reminders",
            "Reduces call-center volume drastically",
        ],
    },
    {
        key: "travel",
        accent: "#5FA88A",
        name: "Travel & Hospitality",
        subtitle: "How NyraAI supports guests from planning to checkout.",
        icon: "fa-solid fa-plane",
        bullets: [
            "Flight, hotel, and cab bookings in chat",
            "Automated booking confirmations and updates",
            "Easy cancellations and reschedules",
            "Special requests handled instantly",
            "Post-trip feedback and loyalty signups",
        ],
    },
    {
        key: "insurance",
        accent: "#2E7D6B",
        name: "Insurance",
        subtitle: "How NyraAI helps users understand, buy, and claim easily.",
        icon: "fa-solid fa-umbrella",
        bullets: [
            "Policy comparison and premium quotes",
            "Pre-qualification and issuance support",
            "Guided claim filing and tracking",
            "Timely renewal reminders and payments",
            "Status checks without agent calls",
        ],
    },
    {
        key: "real-estate",
        name: "Real Estate",
        subtitle: "How NyraAI qualifies, educates, and books site visits.",
        icon: "fa-solid fa-house",
        bullets: [
            "24/7 lead capture and qualification",
            "Instant property listings and brochures",
            "Site visit and virtual tour scheduling",
            "Answers pricing and loan queries",
            "Automated follow-ups for warm leads",
        ],
    },
    {
        key: "education",
        accent: "#4A9683",
        name: "Education & EdTech",
        subtitle: "How NyraAI supports institutions, coaching centers, and edtechs.",
        icon: "fa-solid fa-graduation-cap",
        bullets: [
            "Instant course and fee information",
            "Application and document submission guidance",
            "Class, exam, and fee reminders",
            "Student FAQs on results and policies",
            "Personalized admission campaign follow-ups",
        ],
    },
    {
        key: "logistics",
        accent: "#4A9683",
        name: "Logistics & Delivery",
        subtitle: "How NyraAI keeps customers informed and operations efficient.",
        icon: "fa-solid fa-truck",
        bullets: [
            "Live shipment tracking updates",
            "Easy address changes and reschedules",
            "Delivery notifications and alerts",
            "In-chat feedback collection",
            "Instant resolution of tracking queries",
        ],
    },
];

// Kept for legacy references in the Industries page + demo modal industry select.
export const INDUSTRIES = USE_CASES.map((u) => ({
    key: u.key,
    name: u.name,
    body: u.subtitle,
    icon: u.icon,
}));

export const OFFICES = [
    {
        key: "noida",
        label: "Corporate Office",
        city: "Noida",
        address: "C-25, 5th Floor, Office #01, Tower B, Stellar IT Park, Sector-62, Noida-201309, UP, India",
        phone: "+91-7428923652",
        email: "help@nyrabot.ai",
    },
    {
        key: "gurugram",
        label: "Registered Office",
        city: "Gurugram",
        address: "626, 6th Floor, Tower A, Emaar Digital Greens, Golf Course Extension Road, Sector-61, Gurugram-122102",
        phone: "+91-7428923652",
        email: "help@nyrabot.ai",
    },
    {
        key: "bangalore",
        label: "Office",
        city: "Bangalore",
        address: "GTS Techlabs Cowrks, 12th Floor, Next to RMZ Galleria Mall, Yelahanka, Bangalore-560064",
        phone: "+91-7428923652",
        email: "help@nyrabot.ai",
    },
    {
        key: "mumbai",
        label: "Office",
        city: "Mumbai",
        address: "GTS Telecom Services (I) Pvt Ltd., B-3008, Akshar Business Park, Plot No. 03, Sector 25, Vashi, Navi Mumbai-400703, Maharashtra",
        phone: "+91-7428923652",
        email: "help@nyrabot.ai",
    },
];

export const FAQS = [
    {
        q: "What is NyraAI and how does it work?",
        a: "NyraAI is an AI-powered conversational platform that automates customer conversations across web, chat, voice, WhatsApp, and other channels. It uses intent recognition, retrieval-grounded knowledge, and dynamic workflows to understand customer requests, act on them, and hand off to a human agent when needed — all inside your existing stack.",
    },
    {
        q: "Which channels does NyraAI support?",
        a: "Web (Webbot), web + mobile chat (Chatbot), inbound and outbound voice calls (Voicebot), WhatsApp Business, SMS, and email. With NyraAI Omnichannel you can run one unified bot across all of them from a single dashboard.",
    },
    {
        q: "Can I customize NyraAI's responses?",
        a: "Yes. NyraAI learns from your content, product catalog, FAQs, and policies. You control tone, brand voice, escalation rules, approved templates, and the specific workflows the bot can execute — with a governance layer so nothing goes out that shouldn't.",
    },
    {
        q: "Is NyraAI suitable for my industry?",
        a: "NyraAI is deployed across Healthcare, E-commerce & Retail, Banking & Finance, Insurance, Travel & Hospitality, Real Estate, Education & EdTech, and Logistics & Delivery. Each vertical has proven playbooks — from patient triage to claims filing, order tracking to lead qualification.",
    },
    {
        q: "What languages does NyraAI support?",
        a: "NyraAI is multilingual by design — English plus major Indian languages including Hindi, Bengali, Tamil, Telugu, Marathi, Kannada, Gujarati, Punjabi, and Malayalam. Additional languages can be enabled on request.",
    },
];

export const LANGUAGES = [
    "English",
    "हिन्दी",
    "বাংলা",
    "தமிழ்",
    "తెలుగు",
    "मराठी",
    "ಕನ್ನಡ",
    "ગુજરાતી",
    "ਪੰਜਾਬੀ",
    "മലയാളം",
];

export const CHANNELS = ["WhatsApp", "Web", "Mobile", "Voice", "Email", "SMS", "RCS"];


// ---------- Competitive upgrades (impact bar, trust, demo, compare, case studies, integrations) ----------

export const METRICS = [
    { value: 22, suffix: "+", label: "Indian languages", sub: "natively trained — not translated", accent: "#235F52" },
    { value: 85, suffix: "%", label: "auto-resolution", sub: "from day one, no human touch", accent: "#B0B978" },
    { value: 5, suffix: " days", label: "median go-live", sub: "from kickoff to production", accent: "#5FA88A" },
    { value: 24, suffix: "×7", label: "always-on presence", sub: "zero wait time on any channel", accent: "#D4B542" },
];

// Category-leader wordmarks (anonymized archetypes — honest, and industry-standard for enterprise-first launches).
export const CUSTOMER_MARKS = [
    "TOP-3 PRIVATE BANK",
    "LEADING NBFC LENDER",
    "PUBLIC-SECTOR INSURER",
    "TIER-1 TELECOM",
    "CENTRAL GOVT DEPT.",
    "GLOBAL BPO",
    "MULTI-STATE COOP BANK",
    "NATIONAL HEALTH PAYER",
];

export const CERTIFICATIONS = [
    { name: "SOC 2 Type II", icon: "fa-solid fa-shield-halved" },
    { name: "HIPAA-ready", icon: "fa-solid fa-user-shield" },
];

// Interactive "Try NYRA" scripted scenarios.
export const TRY_NYRA_SCENARIOS = [
    {
        key: "loan",
        tab: "Loan exception",
        query: "Customer 4821 requested waiver on late fee — flagged for review.",
        intent: "Late-fee waiver · underwriting exception",
        sources: [
            { doc: "Retail Credit Policy §4.3", chunk: "Late-fee waivers permitted for accounts in good standing with prior-12-month record clean of chargebacks.", confidence: 0.94 },
            { doc: "Exception Matrix v7", chunk: "Waiver threshold: up to ₹5,000 with team-lead approval; above requires credit-lead sign-off.", confidence: 0.91 },
            { doc: "Prior case #C-2274", chunk: "Similar case approved 18 Jan — customer retained; NPS +12.", confidence: 0.88 },
        ],
        recommendation: "Approve waiver up to ₹5,000 with team-lead sign-off. Escalate above threshold.",
        confidence: 92,
        approver: "Credit Team Lead",
    },
    {
        key: "claims",
        tab: "Claims triage",
        query: "Motor claim received via email — total loss suspected, damage photos attached.",
        intent: "First-notification-of-loss · total-loss triage",
        sources: [
            { doc: "Motor Claims SOP §2.1", chunk: "Suspected total-loss triggers surveyor assignment within 4 business hours.", confidence: 0.96 },
            { doc: "Salvage Rate Schedule Q1", chunk: "Vehicle segment C: salvage value 22–28% of IDV depending on age band.", confidence: 0.89 },
            { doc: "Fraud Signals Playbook", chunk: "Photo-only submission without FIR requires enhanced verification before payout.", confidence: 0.83 },
        ],
        recommendation: "Assign surveyor, request FIR, freeze payout until verified. Draft customer holding-response.",
        confidence: 88,
        approver: "Claims Team Lead",
    },
    {
        key: "policy",
        tab: "Policy question",
        query: "Employee asks: Am I eligible for the ESPP if I joined mid-quarter?",
        intent: "HR benefits eligibility · ESPP enrollment window",
        sources: [
            { doc: "ESPP Plan Document §3.2", chunk: "Employees joining after the first day of a purchase period may enroll in the next window.", confidence: 0.97 },
            { doc: "HR FAQ 2026-Q1", chunk: "Next enrollment window opens 1 Apr; contribution capped at 15% of base salary.", confidence: 0.93 },
        ],
        recommendation: "Not eligible for current window; will be enrolled from next window starting 1 Apr. Sending FAQ link.",
        confidence: 96,
        approver: null,
    },
    {
        key: "healthcare",
        tab: "Patient triage",
        query: "New patient chat: 'I have chest tightness after climbing stairs and mild shortness of breath — should I come in today?'",
        intent: "Symptom triage · cardiology · same-day appointment request",
        sources: [
            { doc: "Cardiology Triage Protocol v3.1", chunk: "Exertional chest tightness with dyspnea in adults 40+ warrants same-day evaluation; rule out ACS before elective scheduling.", confidence: 0.95 },
            { doc: "Consultant Roster · This Week", chunk: "Dr. Menon (cardiology) has same-day slots at 14:20 and 15:40; walk-in triage available via ER intake.", confidence: 0.92 },
            { doc: "Patient History · MRN 84291", chunk: "Age 52 · hypertension · statin therapy · last ECG 11 months ago.", confidence: 0.88 },
        ],
        recommendation: "Route to same-day cardiology slot at 14:20 with pre-visit ECG. Advise: come in today; if symptoms worsen (crushing pain, radiation, sweating), call 108 immediately.",
        confidence: 91,
        approver: "Duty Cardiologist",
    },
    {
        key: "ecommerce",
        tab: "Cart recovery",
        query: "WhatsApp inbound from customer #C-9142: 'Is the size 8 blue running shoes still available? I left them in my cart yesterday.'",
        intent: "Cart-abandonment recovery · stock check · discount eligibility",
        sources: [
            { doc: "Inventory · SKU RS-BLU-08", chunk: "12 units in stock at Bengaluru warehouse; next-day delivery available across metro pincodes.", confidence: 0.98 },
            { doc: "Cart Log · C-9142", chunk: "Abandoned 22h ago · cart value ₹4,299 · previously purchased ₹18,400 lifetime.", confidence: 0.96 },
            { doc: "Recovery Campaign Rules", chunk: "High-LTV customers with 12h+ abandonment eligible for auto-generated 8% code; expires in 4 hours.", confidence: 0.92 },
        ],
        recommendation: "Confirm stock, share 8% recovery code SAVE8-C9142 (4-hour expiry), and pre-fill checkout with next-day delivery. If no reply in 60 min, send image + review carousel.",
        confidence: 94,
        approver: null,
    },
    {
        key: "real-estate",
        tab: "Lead qualification",
        query: "Website enquiry: 'Interested in a 3BHK in Whitefield under ₹1.6 Cr with home-loan help. Prefer weekend site visit.'",
        intent: "Buyer lead qualification · inventory match · visit scheduling",
        sources: [
            { doc: "Live Inventory · Whitefield", chunk: "5 matching 3BHK units across Emerald Heights (₹1.42 Cr) and Skyline Grand (₹1.55 Cr); ready-to-move.", confidence: 0.96 },
            { doc: "Home-Loan Partners", chunk: "Pre-approved partner tie-ups: HDFC, ICICI, SBI · eligibility calculator available in-chat.", confidence: 0.94 },
            { doc: "Sales Rep Roster", chunk: "Weekend site-visit slots open at 11:00 and 15:30 Saturday · Rep: Anita Desai (Whitefield desk).", confidence: 0.90 },
            { doc: "Lead Scoring Model", chunk: "Budget-match + weekend intent + loan-need = warm-lead score 82/100 · assign human within 30 min.", confidence: 0.87 },
        ],
        recommendation: "Send 2-property brochure (Emerald Heights, Skyline Grand), open 11:00 Sat slot, and share loan-eligibility calculator. Warm-lead alert to Anita Desai for follow-up call.",
        confidence: 89,
        approver: "Sales Rep — Anita Desai",
    },
];

// Direct competitive positioning matrix.
export const COMPARE_MATRIX = {
    columns: ["NYRA AI", "Generic Chatbot", "RPA / Workflow", "LLM Copilot"],
    rows: [
        { feature: "Grounded in your enterprise knowledge", values: ["yes", "no", "no", "partial"] },
        { feature: "Sources + confidence on every answer", values: ["yes", "no", "no", "no"] },
        { feature: "Human-in-the-loop approvals", values: ["yes", "no", "partial", "no"] },
        { feature: "Executes end-to-end workflows", values: ["yes", "no", "yes", "no"] },
        { feature: "Handles judgment-heavy exceptions", values: ["yes", "no", "no", "partial"] },
        { feature: "Full audit trail + AI observability", values: ["yes", "no", "partial", "no"] },
        { feature: "Private, in-your-environment deployment", values: ["yes", "no", "yes", "partial"] },
        { feature: "Works across O365, CRM, ERP, core systems", values: ["yes", "partial", "yes", "partial"] },
    ],
};

// Named case studies (anonymized archetypes with realistic outcomes).
export const CASE_STUDIES = [
    {
        key: "cs-bank",
        industry: "Banking",
        org: "Top-3 Indian Private Bank",
        solution: "NYRA TESS",
        metric: "62%",
        metricLabel: "faster email response",
        story: "Rolled TESS across a 240-agent servicing team. Drafted responses grounded in policy & past cases, agents approve and send. First-contact resolution up 41%, escalations down 28% in 90 days.",
        tags: ["Email intelligence", "240 agents", "90-day rollout"],
    },
    {
        key: "cs-nbfc",
        industry: "NBFC",
        org: "Leading NBFC Lender",
        solution: "NYRA Assist + Process Automation",
        metric: "3.4×",
        metricLabel: "collections agent productivity",
        story: "Deployed Assist for collections workflows across WhatsApp, voice, and email. Promise-to-pay tracking automated end-to-end; agents handle judgement-heavy cases only. Recovery lifted 19% Q-over-Q.",
        tags: ["Collections", "WhatsApp + voice", "Q-over-Q +19%"],
    },
    {
        key: "cs-insurer",
        industry: "Insurance",
        org: "Public-Sector Insurer",
        solution: "NYRA Knowledge + Compliance AI",
        metric: "89%",
        metricLabel: "first-contact resolution",
        story: "Unified 12+ years of underwriting circulars, product manuals, and regulatory updates into a governed knowledge layer. Contact-center FCR up from 61% → 89%; compliance audit prep cut from 6 weeks to 4 days.",
        tags: ["Knowledge", "Compliance", "12+ years indexed"],
    },
];

export const INTEGRATIONS = [
    { name: "Microsoft 365", category: "Productivity", icon: "fa-brands fa-microsoft" },
    { name: "Google Workspace", category: "Productivity", icon: "fa-brands fa-google" },
    { name: "WhatsApp Business", category: "Comms", icon: "fa-brands fa-whatsapp" },
    { name: "Twilio Voice", category: "Comms", icon: "fa-solid fa-phone" },
    { name: "Salesforce", category: "CRM", icon: "fa-brands fa-salesforce" },
    { name: "HubSpot", category: "CRM", icon: "fa-brands fa-hubspot" },
    { name: "Zoho CRM", category: "CRM", icon: "fa-solid fa-briefcase" },
    { name: "Zendesk", category: "Support", icon: "fa-solid fa-headset" },
    { name: "Freshdesk", category: "Support", icon: "fa-solid fa-life-ring" },
    { name: "ServiceNow", category: "Support", icon: "fa-solid fa-gears" },
    { name: "Jira", category: "Support", icon: "fa-brands fa-jira" },
    { name: "SAP", category: "ERP", icon: "fa-solid fa-database" },
    { name: "Oracle EBS", category: "ERP", icon: "fa-solid fa-server" },
    { name: "Workday", category: "ERP", icon: "fa-solid fa-people-group" },
    { name: "SharePoint", category: "Data", icon: "fa-brands fa-microsoft" },
    { name: "Confluence", category: "Data", icon: "fa-brands fa-confluence" },
    { name: "MongoDB", category: "Data", icon: "fa-solid fa-leaf" },
    { name: "Snowflake", category: "Data", icon: "fa-solid fa-snowflake" },
    { name: "Postgres", category: "Data", icon: "fa-solid fa-database" },
    { name: "S3 / Object Storage", category: "Data", icon: "fa-solid fa-cloud" },
    { name: "DocuSign", category: "Productivity", icon: "fa-solid fa-file-signature" },
    { name: "Finacle / Flexcube", category: "Core Banking", icon: "fa-solid fa-building-columns" },
];

export const INTEGRATION_CATS = ["All", "Productivity", "Comms", "CRM", "Support", "ERP", "Data", "Core Banking"];

export const TRUST_PILLARS = [
    {
        icon: "fa-solid fa-plug",
        title: "Plugs into what you already run.",
        body: "Connect to your CRM, ticketing, telephony, and IVR. NyraAI augments — it doesn't rip and replace.",
    },
    {
        icon: "fa-solid fa-user-check",
        title: "Human-in-the-loop, where it matters.",
        body: "Warm handoffs the moment intent or emotion demands a human, with full conversation context.",
    },
    {
        icon: "fa-solid fa-lock",
        title: "Private and secure by design.",
        body: "Private deployments, role-based access control, and your data kept in your environment.",
    },
    {
        icon: "fa-solid fa-eye",
        title: "Fully observable.",
        body: "Call intent, sentiment, resolution, and deflection — analytics on every conversation.",
    },
    {
        icon: "fa-solid fa-language",
        title: "Speaks your customer's language.",
        body: "Multilingual by design — English plus every major Indian language, extendable on request.",
    },
];

// -------- Brochure-sourced additions --------
export const HERO_GREETINGS = [
    { lang: "English",   text: "Hello 👋" },
    { lang: "हिन्दी",     text: "नमस्ते 🙏" },
    { lang: "தமிழ்",      text: "வணக்கம் 🙏" },
    { lang: "తెలుగు",     text: "నమస్కారం 🙏" },
    { lang: "বাংলা",       text: "নমস্কার 🙏" },
    { lang: "मराठी",      text: "नमस्कार 🙏" },
    { lang: "ಕನ್ನಡ",       text: "ನಮಸ್ಕಾರ 🙏" },
    { lang: "ગુજરાતી",    text: "નમસ્તે 🙏" },
    { lang: "ਪੰਜਾਬੀ",     text: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ 🙏" },
    { lang: "മലയാളം",    text: "നമസ്കാരം 🙏" },
    { lang: "ଓଡ଼ିଆ",       text: "ନମସ୍କାର 🙏" },
    { lang: "اردو",       text: "السلام علیکم 🙏" },
];

export const LIVE_ACTIONS = [
    { icon: "fa-solid fa-check",        color: "#5FA88A", text: "Resolved KYC for +91-98xx1284 · WhatsApp",           t: "2s ago" },
    { icon: "fa-solid fa-phone-volume", color: "#D4B542", text: "Voicebot handled call · Tamil · 47s · resolved",     t: "4s ago" },
    { icon: "fa-solid fa-bolt",         color: "#235F52", text: "Auto-approved late-fee waiver · Acct #4821",         t: "7s ago" },
    { icon: "fa-solid fa-calendar-check", color: "#DDD188", text: "Booked cardiology slot for Priya · 14:20 today",    t: "9s ago" },
    { icon: "fa-brands fa-whatsapp",    color: "#5FA88A", text: "Cart recovered · #C-9142 · code SAVE8-C9142 sent",   t: "12s ago" },
    { icon: "fa-solid fa-truck",        color: "#5FA88A", text: "Shipment ETA updated for AWB 748219321 · Bengaluru", t: "15s ago" },
    { icon: "fa-solid fa-file-signature", color: "#B0B978", text: "e-KYC completed · Aadhaar OTP verified · Gujarat",  t: "18s ago" },
    { icon: "fa-solid fa-language",     color: "#2E7D6B", text: "Language auto-switched: English → मराठी · +91-90xx", t: "22s ago" },
    { icon: "fa-solid fa-user-check",   color: "#4A9683", text: "Warm handoff to Anita Desai · full context passed",  t: "26s ago" },
    { icon: "fa-solid fa-headset",      color: "#A8B36E", text: "Voice IVR deflected to WhatsApp · 3-tap resolution", t: "31s ago" },
];

export const BUSINESS_IMPACT = [
    {
        headline: "60%",
        problem: "of inbound calls missed or abandoned",
        loss: "₹2.4 Cr+ lost per year",
        icon: "fa-solid fa-phone-slash",
        color: "#A8B36E",
    },
    {
        headline: "70%",
        problem: "of support tickets are repetitive FAQ queries",
        loss: "70% of agent effort wasted",
        icon: "fa-solid fa-arrows-rotate",
        color: "#D4B542",
    },
    {
        headline: "80%",
        problem: "of vernacular users excluded by English-only bots",
        loss: "22+ languages missing",
        icon: "fa-solid fa-language",
        color: "#235F52",
    },
    {
        headline: "0%",
        problem: "visibility on intent, sentiment, or resolution",
        loss: "Gut-based decisions",
        icon: "fa-solid fa-chart-line",
        color: "#5FA88A",
    },
];

export const CORE_CAPABILITIES = [
    {
        title: "Conversational AI Engine",
        body: "NLU with real-time intent, context memory, sentiment detection. Multi-turn dialogue with TTS/STT.",
        icon: "fa-solid fa-brain",
        color: "#235F52",
    },
    {
        title: "Agentic AI & Decision Intelligence",
        body: "Autonomously analyzes, decides, executes — triggers workflows, approvals, transactions.",
        icon: "fa-solid fa-bolt",
        color: "#B0B978",
    },
    {
        title: "Omnichannel Engagement",
        body: "Unified AI across Voice, Web, WhatsApp, RCS. Seamless channel switching without losing context.",
        icon: "fa-solid fa-network-wired",
        color: "#DDD188",
    },
    {
        title: "Live Agent Handoff",
        body: "Intelligent escalation with full context transfer. Smart routing and warm handoff — zero repetition.",
        icon: "fa-solid fa-user-check",
        color: "#5FA88A",
    },
    {
        title: "Analytics & Insights",
        body: "Real-time dashboards: call volume, intent breakdown, resolution rates, sentiment. Auto-flagging.",
        icon: "fa-solid fa-chart-column",
        color: "#D4B542",
    },
    {
        title: "Enterprise Integration",
        body: "Connects Salesforce, SAP, custom CRM/ERP via RESTful APIs. SSO, multi-tenant, DC/DR ready.",
        icon: "fa-solid fa-plug",
        color: "#5FA88A",
    },
];

export const CERTS_BROCHURE = [
    { name: "SOC 2 Type I", sub: "Security & Availability", icon: "fa-solid fa-lock" },
    { name: "SOC 2 Type II",sub: "Sustained Controls",   icon: "fa-solid fa-user-shield" },
];

export const CERF = {
    parent: "CERF Global Services",
    initiative: "$150M Enterprise Platform",
    countries: "22 Countries",
    hq: "Singapore & Noida",
    indiaOffices: "5 India Offices",
};
